import { Component, OnInit, ViewChild } from '@angular/core';
import * as _ from 'underscore';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from 'src/app/shared/services/data.service';
import { TranslateService } from '@devinforius/i-essentials';
import { TreeSelect } from 'primeng/treeselect';
import { ServicesService } from 'src/app/shared/services/services.service';
import { DropdownRole } from 'src/app/shared/interfaces/roles/dropdown-role.interface';
import { RolesService } from 'src/app/shared/services/roles.service';
import { Cols } from 'src/app/shared/models/cols';
import { DateUtils } from 'src/app/utils/date.utils';
import {
  RapportDocument,
  RapportDocumentDTO,
  RapportDocumentFilesValidationSignatureParams,
} from 'src/app/shared/models/iCourrier/rapport-document/rapport-document';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { DocumentValidationStatusDTO } from 'src/app/shared/interfaces/documents/document-validation-status-dto.interface';
import { DocumentSignatureStatusDTO } from 'src/app/shared/interfaces/documents/document-signature-status-dto.interface';
import { FilesService } from 'src/app/shared/services/files.service';
import { ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { environment } from 'src/environments/environment';
import { ITabs } from '@devinforius/i-navigation';
import { manageServicesSetAsTreeSelect, manageServicesToBeMerged } from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { catchError, forkJoin, of } from 'rxjs';
import { DropdownService } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss'],
})
export class ReportingComponent implements OnInit {
  @ViewChild('treeSelect') treeSelect: TreeSelect;

  public tabsArray: ITabs[] = [
    { header: 'En cours', id: 'pending', active: true },
    { header: 'Terminé', id: 'finished' },
  ];

  public params: RapportDocumentFilesValidationSignatureParams = {
    SvcPropId: null,
    DtUploadMin: null,
    DtUploadMax: null,
    StatusValidation: null,
    StatusSignature: null,
    SearchTag: 'EnCours',
  };
  public paramsCount = 0;
  public statusValidation: { label: string; value: number }[] = [];
  public statusSignature: { label: string; value: number }[] = [];

  public files: RapportDocumentDTO[] = [];
  public columnTable: Cols[] = [
    {
      field: 'mailId',
      header: 'Courrier',
      format: (value: number): string => {
        if (value) {
          return value.toString();
        } else {
          return '/';
        }
      },
    },
    {
      field: 'fileName',
      header: 'Nom',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'statusSignature',
      header: 'Signature',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'statusValidation',
      header: 'Validation',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'roleSignature',
      header: 'Rôle signature.',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'validationSignature',
      header: 'Rôle validation',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'date',
      header: 'Date',
      format: (value: Date): string => {
        if (value) {
          return DateUtils.format(value, 'DD/MM/YYYY');
        } else {
          return '/';
        }
      },
      sort: (a: Date, b: Date, order: number): number => {
        const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
        const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
    {
      field: 'serviceName',
      header: 'Service',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'typeEntrantSortant',
      header: 'Type',
      format: (value: string): string => {
        if (value === 'E') {
          return 'Entrants';
        } else if (value === 'S') {
          return 'Sortants';
        } else {
          return 'Interne';
        }
      },
    },
  ];
  public idTable = 'reporting';
  public rolesLV: DropdownRole[] = [];
  public serviceParent: ServicesPTreeSelect[] = [];
  public servicesFusionned: {
    label: string;
    value: number;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public selectedOption = null;
  public translationPlaceholderPTree: string = null;
  public openAdvancedSearchModal = false;
  public formNeedsToBeReset = false; // Used to tell que modal that it should be reset. Needed to reset the p-treeSelect 'cause this one needs to be displayed to be reset
  constructor(
    public toastr: ToastrService,
    public spinner: NgxSpinnerService,
    public dataService: DataService,
    public translater: TranslateService,
    private servicesService: ServicesService,
    private rolesService: RolesService,
    private documentsService: DocumentsService,
    private filesService: FilesService
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.dataService.setSidebarSmall(false);
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');

    forkJoin({
      services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors du chargement des services');
          return of(null);
        })
      ),
      roles: this.rolesService.getRolesMappedToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors du chargement des rôles');
          return of(null);
        })
      ),
      validationStatus: this.documentsService.getStatusValidationGlobal().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors du chargement des statuts de validation');
          return of(null);
        })
      ),
      signatureStatus: this.documentsService.getStatusSignatureGlobal().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue lors du chargement des statuts de signature');
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.formatServices(value.services);
      this.rolesLV = value.roles;
      this.formatValidationStatus(value.validationStatus);
      this.formatSignatureStatus(value.signatureStatus);
      this.getMails();
    });
  }

  private formatServices(services: DropdownService[]): void {
    const datasForService = manageServicesSetAsTreeSelect(services, this.translater);
    this.serviceParent = datasForService.servicesForSingleCheck;
    this.servicesFusionned = manageServicesToBeMerged(services);
  }

  private formatValidationStatus(status: DocumentValidationStatusDTO[]): void {
    if (status.length > 0) {
      status.forEach((item) => {
        this.statusValidation.push({ label: item.description, value: item.id });
      });
    }
  }

  private formatSignatureStatus(status: DocumentSignatureStatusDTO[]): void {
    if (status.length > 0) {
      status.forEach((item) => {
        this.statusSignature.push({ label: item.description, value: item.id });
      });
    }
  }

  receive_tabs(value): void {
    if (value === 'En cours') {
      this.params.SearchTag = 'EnCours';
    } else {
      this.params.SearchTag = 'Termine';
    }
    this.getMails();
  }

  getMails(): void {
    this.files = [];
    const data = Object.assign({}, this.params);

    if (data.DtUploadMin) {
      data.DtUploadMin = DateUtils.format(data.DtUploadMin, 'YYYY-MM-DD');
    }
    if (data.DtUploadMax) {
      data.DtUploadMax = DateUtils.format(data.DtUploadMax, 'YYYY-MM-DD');
    }
    this.filesService.getValidationSignatureMails(data).subscribe({
      next: (res: RapportDocumentDTO[]) => {
        if (res?.length > 0) {
          res.map((item) => {
            const itemModified = new RapportDocument(item);
            if (itemModified?.file) {
              if (itemModified.file.procedureValidationValidationOk !== null) {
                let temp = [];
                temp = _.first(this.statusValidation.filter((x) => x.value === itemModified.file.procedureValidationValidationOk));
                if (temp) {
                  itemModified.statusValidation = temp['label'];
                  itemModified.statusValidationId = itemModified.file.procedureValidationValidationOk;
                }
              }
              if (itemModified.file.procedureValidationSignatureRoleId !== null) {
                let temp = [];
                temp = _.first(this.rolesLV.filter((x) => x.value === itemModified.file.procedureValidationSignatureRoleId));
                if (temp) {
                  itemModified.roleSignature = temp['label'];
                }
              }
              if (itemModified.file.procedureValidationValidationRoleId !== null) {
                let temp = [];
                temp = _.first(this.rolesLV.filter((x) => x.value === itemModified.file.procedureValidationValidationRoleId));
                if (temp) {
                  itemModified.validationSignature = temp['label'];
                }
              }
              if (itemModified.file.procedureValidationSignatureOk !== null) {
                let temp = [];
                temp = _.first(this.statusSignature.filter((x) => x.value === itemModified.file.procedureValidationSignatureOk));
                if (temp) {
                  itemModified.statusSignature = temp['label'];
                  itemModified.statusSignatureId = itemModified.file.procedureValidationSignatureOk;
                }
              }
              if (itemModified.serviceProprietaireId !== null) {
                let temp = [];
                temp = _.first(this.servicesFusionned.filter((x) => x.value === itemModified.serviceProprietaireId));
                if (temp) {
                  itemModified.serviceName = temp['label'];
                }
              }
              itemModified.fileName = itemModified.file.description;
              itemModified.version = itemModified.file.version;
              itemModified.date = itemModified.file.dateUpload;
              itemModified.id = itemModified.file.id;
              this.files.push(itemModified);
            }
          });
        }
        this.spinner.hide();
      },
    });
  }

  showDialog(value: RapportDocument): void {
    const url = '/private/ic/tabs/';
    const config = environment;
    window.open(config.baseUrl + url + value.mailId);
  }

  filter(): void {
    this.paramsCount = 0;
    Object.keys(this.params).forEach((key) => {
      // on ne veut pas compter le "SearchTag" car c'est un filtre "passif"
      if (this.params[key] !== null && key !== 'SearchTag') {
        this.paramsCount += 1;
      }
    });
    this.openAdvancedSearchModal = false;
    this.getMails();
  }

  openSearchModal(): void {
    this.openAdvancedSearchModal = true;
    this.params.DtUploadMin ? (this.params.DtUploadMin = new Date(this.params.DtUploadMin)) : null;
    this.params.DtUploadMax ? (this.params.DtUploadMax = new Date(this.params.DtUploadMax)) : null;
    // setTimeout obligé car sinon le p-tree n'a pas le temps de s'afficher
    setTimeout(() => {
      // Si on ne doit pas reset ET que l'on a un id à setter, alors on va setter.
      // Si pas on va juste reset
      if (!this.formNeedsToBeReset && this.params.SvcPropId) {
        this.setPTree({ node: { value: this.params.SvcPropId } });
      } else {
        this.resetPTree();
      }
    }, 0);
  }

  reset(reloadMails = false): void {
    this.params.SvcPropId = null;
    this.params.DtUploadMin = null;
    this.params.DtUploadMax = null;
    this.params.StatusValidation = null;
    this.params.StatusSignature = null;
    this.formNeedsToBeReset = true;
    this.paramsCount = 0;
    // Si la modale est ouverte on va forcer le reset de p-tree
    if (this.openAdvancedSearchModal) this.resetPTree();
    if (reloadMails) this.getMails();
  }

  /**
   * * Method to add p-highlight class to current service selected
   */
  onShowTreeSelect(): void {
    if (this.selectedOption) {
      const aTags = document.getElementsByClassName('p-treenode-content');
      let found;
      if (aTags && aTags.length > 0) {
        for (let i = 0; i < aTags.length; i++) {
          if (aTags[i].textContent == this.selectedOption.label) {
            found = aTags[i];
            found.classList.add('p-highlight');
            break;
          }
        }
      }
    }
  }

  select(event): void {
    if (event.node && event.node.value) {
      if (this.selectedOption?.value !== event.node.value) {
        this.setPTree(event);
      } else {
        this.resetPTree();
      }
      this.params.SvcPropId = this.selectedOption?.value ? this.selectedOption?.value : null;
    }
  }

  setPTree(service): void {
    this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === service.node.value));
    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
    labelTreeHtml[0].innerHTML = this.selectedOption.label;
  }

  resetPTree(): void {
    this.selectedOption = null;
    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
    labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
    this.treeSelect.value = [];
  }
}
